import {
  type ApiRequest,
  ApiResponseSingle,
  properCallApi
} from '@/api/tenantClient';

export interface PageVisitResponse {
  errors: string[]
}

export interface CreatePageVisitRequest {
  registrationId: number
  pageName: string
}

export function createPageVisit(createTenantAdminRequest: () => ApiRequest) {
  const request = createTenantAdminRequest();
  return async (params: CreatePageVisitRequest): Promise<ApiResponseSingle<PageVisitResponse>> => {
    request.method = 'POST';
    request.endpoint.path = '/api/v1/registrations/create_page_visit';
    request.payload = {
      registration_id: params.registrationId,
      page_name: params.pageName
    };
    return await properCallApi<ApiResponseSingle<PageVisitResponse>>(request);;
  };
}
